import { Fragment } from 'react'
import Table from 'components/table/Table'
import { useSelector } from 'react-redux'
import MultiTable from 'components/table/MultiTable'
import classNames from 'classnames'
import {
  ReportColumnCampaignName,
  ReportColumnCampaignType,
} from 'features/report/common/ReportColumns'
import HelpTooltip from '../../../components/tooltip/HelpTooltip'

const ReportFixedTable = () => {
  const { reports, unfold } = useSelector(state => state.report.reportAdd)
  return (
    <div className="table_fixed" style={{ width: 358 }}>
      <MultiTable className="tbl_g" caption="캠페인명 테이블">
        <Table.Head>
          <Table.Column
            title={
              <>
                유형
                <HelpTooltip>
                  광고상품을 구분하는 정보로 프리미엄링크와 톡채널검색으로
                  구분됩니다.
                </HelpTooltip>
              </>
            }
            minWidth={161}
          />
          <Table.Column title="캠페인" minWidth={185} />
        </Table.Head>
        <Table.Body>
          {reports.map((report, index) => (
            <Fragment key={index}>
              <Table.Row rowId={index} hoverClassName="over">
                <ReportColumnCampaignType.render
                  text={report.campaignType}
                  title={report.campaignType}
                />
                <ReportColumnCampaignName.render
                  text={report.campaignName}
                  title={report.campaignName}
                  deleted={report[ReportColumnCampaignName.deleted]}
                />
              </Table.Row>
              {report.splits.map((split, innerIndex) => (
                <Table.Row
                  rowId={`inner${innerIndex}`}
                  key={innerIndex}
                  className={classNames('tr_depthitem', {
                    hide: !unfold.includes(index),
                  })}>
                  <td />
                  <td />
                </Table.Row>
              ))}
            </Fragment>
          ))}
        </Table.Body>
      </MultiTable>
    </div>
  )
}

export default ReportFixedTable
